// extracted by mini-css-extract-plugin
export default {"breakpointDesktopMinWidth":"1200px","dpWhite":"#fff","dpGainsboro":"#e6e6e6"};